import {
    WindowDoorAction,
    WindowDoorActionTypes,
    UpdateWindowDoorConfiguration,
    fromWindowDoorActions,
} from './window-door.actions';
import { SharedAction } from '@icc/configurator/shared';
import { IWindowActiveConfiguration } from '@icc/window-door/types';

export const WINDOW_DOOR_FEATURE_KEY = 'windowDoor';
// Legacy export
export const WINDOW_FEATURE_KEY = WINDOW_DOOR_FEATURE_KEY;

export interface WindowDoorState {
    configuration: IWindowActiveConfiguration | null;
}

export interface WindowDoorPartialState {
    readonly [WINDOW_DOOR_FEATURE_KEY]: WindowDoorState;
}

// Legacy export
export type WindowState = WindowDoorState;
export type WindowPartialState = WindowDoorPartialState;

export const initialState: WindowDoorState = {
    configuration: null,
};

export function windowDoorReducer(
    state: WindowDoorState = initialState,
    action: WindowDoorAction | SharedAction
): WindowDoorState {
    switch (action.type) {
        case WindowDoorActionTypes.UpdateWindowDoorConfiguration: {
            return {
                ...state,
                configuration: {
                    ...action.payload.configuration,
                },
            };
            break;
        }
    }
    return state;
}

// Legacy export
export const windowReducer = windowDoorReducer;
